import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private showLoader: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public get loadingState$(): BehaviorSubject<boolean> {
    return this.showLoader;
  }

  public present(): void {
    this.showLoader.next(true);
  }

  public dismiss(): void {
    this.showLoader.next(false);
  }
}
